import { Injectable, Inject, Output, EventEmitter} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject} from 'rxjs/Subject';
import { Http, Response} from '@angular/http';
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import {ActivatedRoute, Router} from '@angular/router';

/**
 * Author: Noraini A.Ghani
 * 
 * Date Created: January 19 2018
 * 
 * Description: Class for Announcementlist Service (obsolete).
 **/
@Injectable()
export class AnnouncementlistService {
  @Output() menuClick = new EventEmitter();
  announces: any[]; // announcement component
  announceDetails: any[]; // announcement details component

  constructor(private http: Http, @Inject(APP_CONFIG) private config: AppConfig,
  route: ActivatedRoute, private router: Router) { }

  getAnnounces() {
      return this.anounce;
  }

  public anounce = {
      name: 'hello'
  };

  private announceUrl: string = this.config.urlAnnouncementSub;

}



// WEBPACK FOOTER //
// ./src/app/announcementlist/announcementlist.service.ts